module.exports = __webpack_public_path__ + "img/img-fun-2.512de109.png";